import React from 'react';
import PropTypes from 'prop-types';

import FluidImage from 'components/FluidImage';
import { VACANCYCARDTHEMES} from 'constants/vacancyCardThemes';
import './VacancyCard.scss';
import Icon from 'components/Icon';
import cn from 'classnames';

const VacancyCard = ({
    name,
    location,
    categories,
    deadline,
    image,
    link,
    displayImage,
    theme,
    className,
    onScreen,
}) => (
    <a 
        className={cn("vacancy-card", {
            [`vacancy-card_theme_${VACANCYCARDTHEMES[theme]}`]: theme,
            [className]: className
        })} 
        href={link} data-card="vacancy"
    >
        <div className="vacancy-card__content">
            <p className="vacancy-card__title">{name}</p>
            <ul className="vacancy-card__info">
                {location && (
                    <li>
                        <Icon icon="location" />
                        <span>{location}</span>
                    </li>
                )}
                {categories && (
                    <li>
                        <Icon icon="briefcase" />
                        <span>{categories}</span>
                    </li>
                )}
                {deadline && (
                    <li>
                        <Icon icon="calendar" />
                        <span>{deadline}</span>
                    </li>
                )}
            </ul>
        </div>
        {(image && displayImage) && (
            <div className="vacancy-card__image-wrapper">
                <FluidImage
                    className="vacancy-card__image"
                    image={image}
                    visible={onScreen}
                />
            </div>
        )}
        {!displayImage && (
            <div className="vacancy-card__arrow">
                <Icon icon="arrow-right" />
            </div>
        )}
    </a>
);

VacancyCard.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    image: PropTypes.string,
    location: PropTypes.string,
    categories: PropTypes.string,
    deadline: PropTypes.string,
    link: PropTypes.string.isRequired,
    displayImage: PropTypes.bool.isRequired,
    className: PropTypes.string,
    onScreen: PropTypes.bool.isRequired,
    theme: PropTypes.oneOf(Object.values(VACANCYCARDTHEMES))
};

VacancyCard.defaultProps = {
    displayImage: true,
    onScreen: true,
    theme: VACANCYCARDTHEMES.default
};

export default VacancyCard;



// WEBPACK FOOTER //
// ./src/components/VacancyCard/VacancyCard.jsx